import { useEffect, useState } from 'react';
import { fetchEVNById, fetchEVNMeters } from '../services/evn.api';

export function useEVNDetails(evnId) {
  const [evnData, setEvnData] = useState(null);
  const [meters, setMeters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ctrl = new AbortController();

    (async () => {
      try {
        setLoading(true);
        const [evn, mtrs] = await Promise.all([
          fetchEVNById(evnId, ctrl.signal),
          fetchEVNMeters(evnId, ctrl.signal),
        ]);
        setEvnData(evn || null);
        setMeters(Array.isArray(mtrs) ? mtrs : []);
      } catch (e) {
        if (e.name !== 'AbortError') {
          console.error('useEVNDetails error:', e);
          setEvnData(null);
          setMeters([]);
        }
      } finally {
        setLoading(false);
      }
    })();

    return () => ctrl.abort();
  }, [evnId]);

  return { evnData, meters, loading };
}
